import { isElementType } from '@lumapps/wrex-core/slate/utils/isElementType';

import { IMAGE_GROUP } from '../constants';
import { ImageGroupElement } from '../types';

export const isImageGroup = isElementType<ImageGroupElement>(IMAGE_GROUP);
